import { render, staticRenderFns } from "./inbound-outbound.vue?vue&type=template&id=74059456&scoped=true&"
import script from "./inbound-outbound.vue?vue&type=script&lang=js&"
export * from "./inbound-outbound.vue?vue&type=script&lang=js&"
import style0 from "./inbound-outbound.vue?vue&type=style&index=0&id=74059456&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74059456",
  null
  
)

export default component.exports